/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Αντιγραφή'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Όνομα'
  },
  LABEL: {
    FILTER_MONTH_APR: 'Απρίλιος',
    FILTER_MONTH_AUG: 'Αύγουστος',
    FILTER_MONTH_DEC: 'Δεκέμβριος',
    FILTER_MONTH_FEB: 'Φεβρουάριος',
    FILTER_MONTH_JAN: 'Ιανουάριος',
    FILTER_MONTH_JUL: 'Ιούλιος',
    FILTER_MONTH_JUN: 'Ιούνιος',
    FILTER_MONTH_MAR: 'Μάρτιος',
    FILTER_MONTH_MAY: 'Μάιος',
    FILTER_MONTH_NOV: 'Νοέμβριος',
    FILTER_MONTH_OCT: 'Οκτώβριος',
    FILTER_MONTH_SEP: 'Σεπτέμβριος',
    GENERATE_HASHTAG: 'Δημιουργία hashtag',
    GENERATE_LINK: 'Δημιουργία συνδέσμου',
    GENERATED_HASHTAG: 'Hashtag που δημιουργείται',
    GENERATED_LINK: 'Παραγόμενος σύνδεσμος',
    MONTH: 'Μήνας',
    NAME: 'Όνομα',
    YEAR: 'Έτος'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Δεν υπάρχουν προϊόντα',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Αλλαγή των κριτηρίων αναζήτησης'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag αντιγραμμένο',
    LINK_COPIED: 'Σύνδεσμος που αντιγράφηκε'
  },
  TOOLTIP: {
    MONTH: 'Μήνας',
    NAME: 'Όνομα',
    YEAR: 'Έτος'
  }
};
